import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[portalSetBackgroundImage]',
  standalone: false,
})
export class SetBackgroundImageDirective implements OnInit {
  private readonly el = inject(ElementRef);

  @Input('portalSetBackgroundImage') path: string;

  ngOnInit(): void {
    if (this.path) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.el.nativeElement.style.backgroundImage = this.urlPath;
    }
  }

  get urlPath(): string {
    if (this.path.includes('url')) {
      return this.path;
    }

    return 'url(' + this.path + ')';
  }
}
